import { EMeteo } from 'src/app/domain/SANDRE/meteo';
import { EEnsoleillement } from 'src/app/domain/SANDRE/ensoleillement';
import { Hydrologie } from 'src/app/domain/SANDRE/hydrologie';
import { VariationDebit } from 'src/app/domain/SANDRE/variation-debit';
import { Limpidite } from 'src/app/domain/SANDRE/limpidite';
import { VisibiliteFond } from 'src/app/domain/SANDRE/visibilite-fond';
import { Odeur } from 'src/app/domain/SANDRE/odeur';
import { Teinte } from 'src/app/domain/SANDRE/teinte';
import { SituationHydrologie6sem } from 'src/app/domain/SANDRE/situation-hydro-6sem';
import { OccupationDominanteRiveGauche } from 'src/app/domain/SANDRE/occ-dominanteRG';
import { OccupationDominanteRiveDroite } from 'src/app/domain/SANDRE/occDominanteRD';
import { NatureBergeGauche } from 'src/app/domain/SANDRE/nature-berge-gauche';
import { NatureBergeDroite } from 'src/app/domain/SANDRE/nature-berge-droite';
import { AspectAbord } from 'src/app/domain/SANDRE/aspect-abord';
import { PresenceSeuil } from 'src/app/domain/SANDRE/presence-seuil';
import { PresenceGué } from 'src/app/domain/SANDRE/presence-gue';
import { ClasseVitesse } from 'src/app/domain/Shared/classe-vitesse';
import { TypeOutilPrelevement } from 'src/app/domain/IBD/enum/type-outil-prelevement';
import { SupportIBD } from 'src/app/domain/IBD/enum/support-IBD';
import { Ombre } from 'src/app/domain/IBD/enum/ombre';
import { IntensiteColmatage } from 'src/app/domain/IBD/enum/intensite-colmatage';
import { ETypeSubstrat as IBGNSub } from 'src/app/domain/IBGN/enum/type-substrat';
import { ETypeSubstrat as MPCESub } from 'src/app/domain/MPCE/enum/type-substrat';
import { ETypeSubstrat as MGCESub } from 'src/app/domain/MGCE/enum/type-substrat';
import { ColmatageLit } from 'src/app/domain/SANDRE/colmatage-lit';
import { Materiel } from 'src/app/domain/Shared/materiel';
import { PresenceRejet } from 'src/app/domain/SANDRE/presense-rejet';
import { EImportanceVegetationBerge } from 'src/app/domain/SANDRE/importance-vegetation-berge';
import { ETypeVegetation } from 'src/app/domain/SANDRE/type-vegetation-name';
import { EDocumentType } from './mutilple-file-upload-box/document-type';
import { AnalyseStatut } from 'src/app/domain/Analyse/enum/analyse-statut';
import { NatureVegetationPlacette } from 'src/app/domain/SANDRE/nature-vegetation';
import { ImportanceVegetationPlacette } from 'src/app/domain/SANDRE/importance-vegetation-placette';
import { MethodePrelevementEau } from 'src/app/domain/EAU/methode-prelevement-eau';
import { EInterventionType } from 'src/app/domain/planning/enum/intervention-type';
import { EIntensiteVent } from 'src/app/domain/Lac - EAU/enum/intensite-vent';
import { ESurfaceEau } from 'src/app/domain/Lac - EAU/enum/surface-eau';
import { EBloomAlgal } from 'src/app/domain/Lac - EAU/enum/bloom-algal';
import { EPresenceMarnage } from 'src/app/domain/Lac - EAU/enum/presence-marnage';
import { EEmplacementMesure } from 'src/app/domain/Lac - EAU/enum/emplacement-mesure';
import { EMaterielEauIntegrePhyto } from 'src/app/domain/Lac - EAU/enum/materiel-eau-integre';
import { EMaterielSediment } from 'src/app/domain/Lac - EAU/enum/materiel-sediment';
import { EMaterielEauPonctuel } from 'src/app/domain/Lac - EAU/enum/materiel-eau-ponctuel';
import { EMasterSondeType } from 'src/app/domain/Shared/enum/master-sonde-type';
import { ERecouvrement } from 'src/app/domain/IBMR/enum/recouvrement';
import { EAbondancePeriphyton } from 'src/app/domain/IBMR/enum/abondance-periphyton';
import { EModeMesure } from 'src/app/domain/Shared/enum/mode-mesure';
import { EZone } from 'src/app/domain/MGCE/enum/zone';
import { EImportance } from 'src/app/domain/MGCE/enum/importance';
import { EModeEstimationRecouvrement } from 'src/app/domain/IBMR/enum/mode-estimation-recouvrement';
import { EModePrelevement } from 'src/app/domain/IBMR/enum/mode-prelevement';
import { ESecuriteMiseALEau } from 'src/app/domain/description/securite-mise-eau';
import { EUniteUR1 } from 'src/app/domain/IBMR/enum/unite-ur1';
import { EUniteUR2 } from 'src/app/domain/IBMR/enum/unite-ur2';
import { EIMLTypeSubstratMineral } from 'src/app/domain/IML/enum/type-substrat-mineral';
import { EIMLTypeSubstratVegetal } from 'src/app/domain/IML/enum/type-substrat-vegetal';
import { ESigneEmergence } from 'src/app/domain/Lac - EAU/enum/signe-emergence';
import { ESousSubstrat } from 'src/app/domain/Shared/enum/sous-substrat';
import { EUnit } from 'src/app/domain/IBMR/enum/unit';
import { EpH } from 'src/app/domain/Shared/enum/pH';
import { EConductivite } from 'src/app/domain/Shared/enum/conductivite';
import { EGroupementPrelevementAnalyse } from 'src/app/domain/Shared/enum/groupement-prelevement-analyse';

export class StringConverter {
    static getGroupementAnalyseName(type: EGroupementPrelevementAnalyse): string {
        switch (type) {
            case EGroupementPrelevementAnalyse.PrelevementPhaseAnalysePhase:
                return '3 phases classiques';
            case EGroupementPrelevementAnalyse.PrelevementPotAnalysePhase:
                return '12 pots regroup. labo';
            case EGroupementPrelevementAnalyse.PrelevementPotAnalysePot:
                return '12 pots séparés';
            default:
                return 'Not Set';
        }
    }

    static getSousSubstratName(type: ESousSubstrat): string {
        switch (type) {
            case ESousSubstrat.Argile:
                return 'Argile';
            case ESousSubstrat.Branchages:
                return 'Branchages';
            case ESousSubstrat.Dalles:
                return 'Dalles';
            case ESousSubstrat.Limons:
                return 'Limons';
            case ESousSubstrat.Marnes:
                return 'Marnes et argiles';
            case ESousSubstrat.Racines:
                return 'Racines';
            case ESousSubstrat.Sables:
                return 'Sables';
            case ESousSubstrat.Algues:
                return 'Algues';
            case ESousSubstrat.DebrisVegetaux:
                return 'Débris végétaux';
            case ESousSubstrat.Galets:
                return 'Galets';
            case ESousSubstrat.Litieres:
                return 'Litières';
            case ESousSubstrat.Pierres:
                return 'Pierres';
            default:
                return 'Not Set';
        }
    }

    static getMasterSondeTypeName(type: EMasterSondeType) {
        switch (type) {
            case EMasterSondeType.Conductivite:
                return 'Conductivité';
            case EMasterSondeType.Oxygene:
                return 'Oxygène';
            case EMasterSondeType.PH:
                return 'pH';
            default:
                return 'Not Set';
        }
    }

    static getInterventionTypeName(m: EInterventionType) {
        switch (m) {
            case EInterventionType.IBD:
                return 'IBD';
            case EInterventionType.IBGN:
                return 'IBGN';
            case EInterventionType.MPCE:
                return 'MPCE / IBG-DCE';
            case EInterventionType.EAU:
                return 'EAU';
            case EInterventionType.LAC:
                return 'LAC';
            case EInterventionType.MGCE:
                return 'MGCE';
            case EInterventionType.IBMR:
                return 'IBMR';
            case EInterventionType.IML:
                return 'IML';
            case EInterventionType.Cyano:
                return 'Cyano';
            default:
                return 'Not Set';
        }
    }

    static getMethodePrelevementEauName(m: MethodePrelevementEau) {
        switch (m) {
            case MethodePrelevementEau.Bateau:
                return 'Bateau';
            case MethodePrelevementEau.PiedsDansEau:
                return 'Pieds dans l\'eau';
            case MethodePrelevementEau.Pont:
                return 'Pont';
            case MethodePrelevementEau.Rive:
                return 'Rive';
            default:
                return 'Not Set';
        }
    }

    static getNatureVegetationPlacetteName(n: NatureVegetationPlacette) {
        switch (n) {
            case NatureVegetationPlacette.Aucune:
                return 'Aucune';
            case NatureVegetationPlacette.Algues:
                return 'Algues';
            case NatureVegetationPlacette.Bryophytes:
                return 'Bryophytes';
            case NatureVegetationPlacette.Helophytes:
                return 'Hélophytes';
            case NatureVegetationPlacette.Hydrophytes:
                return 'Hydrophytes';
            default:
                return 'Not Set';
        }
    }

    static getImportanceVegetationPlacetteName(i: ImportanceVegetationPlacette) {
        switch (i) {
            case ImportanceVegetationPlacette.Faible:
                return 'Faible';
            case ImportanceVegetationPlacette.Importante:
                return 'Importante';
            case ImportanceVegetationPlacette.Moyenne:
                return 'Moyenne';
            case ImportanceVegetationPlacette.Nulle:
                return 'Nulle';
            case ImportanceVegetationPlacette.TresFaible:
                return 'Très faible';
            case ImportanceVegetationPlacette.TresImportante:
                return 'Très importance';
            case ImportanceVegetationPlacette.Indeterminable:
                return 'Indéterminable';
            case ImportanceVegetationPlacette.NonRenseignee:
                return 'Non renseignée';
            default:
                return 'Not Set';
        }
    }

    static getAnalysisStatusName(type: AnalyseStatut) {
        switch (type) {
            case AnalyseStatut.New:
                return 'Nouveau';
            case AnalyseStatut.InProgress:
                return 'En cours';
            case AnalyseStatut.Done:
                return 'Terminée';
            default:
                return 'Not Set';
        }
    }

    static getDocumentTypeName(type: EDocumentType) {
        switch (type) {
            case EDocumentType.AccessPicture:
                return 'Vue d\'accès';
            case EDocumentType.GeneralPicture:
                return 'Vue générale';
            case EDocumentType.DownstreamPicture:
                return 'Vue aval';
            case EDocumentType.UpstreamPicture:
                return 'Vue amont';
            case EDocumentType.OtherPicture:
                return 'Autre photo';
            case EDocumentType.SchemaStation:
                return 'Schéma station';
            case EDocumentType.SEEEExport:
                return 'Export SEEE';
            case EDocumentType.SEEEResult:
                return 'Résultat SEEE';
            case EDocumentType.SEEEIBGDCEResult:
                return 'Résultat SEEE IBG-DCE';
            case EDocumentType.SEEEODIResult:
                return 'Résultat SEEE ODI';
            case EDocumentType.SEEEIBGDCEResult:
                return 'Résultat SEEE IBG-DCE';
            case EDocumentType.OmnidiaResult:
                return 'Résultat Omnidia';
            case EDocumentType.RapportPrelevementExcel:
                return 'Rapport de prélèvement';
            case EDocumentType.RapportPrelevementPDF:
                return 'Rapport de prélèvement';
            case EDocumentType.RapportEssaiExcel:
                return 'Rapport d\'essai';
            case EDocumentType.RapportEssaiPDF:
                return 'Rapport d\'essai';
            case EDocumentType.RapportInterpretationExcel:
                return 'Rapport d\'interprétation';
            case EDocumentType.RapportInterpretationPDF:
                return 'Rapport d\'interprétation';
            case EDocumentType.StationMap:
                return 'Carte';
            case EDocumentType.EBIOCE2018:
                return 'EBIOCE2018';
            case EDocumentType.SaisieMinvCE:
                return 'Saisie Macro-Invertébrés';
            case EDocumentType.SoutienMinvCE:
                return 'Soutien Bio Macro-Invertébrés';
            case EDocumentType.SoutienDiat:
                return 'Soutien Diatomées';
            case EDocumentType.ImportLacTaxons:
                return 'Import liste floristique';
            case EDocumentType.ImportIPLAC:
                return 'Import IPLAC';
            case EDocumentType.RapportEssaiLacEauXls:
                return 'Rapport Essai Lac Eau xls';
            case EDocumentType.RapportEssaiLacEauPdf:
                return 'Rapport Essai Lac Eau Pdf';
            case EDocumentType.RapportInterpretationLacEauXls:
                return 'Rapport Interpretation Lac Eau xls';
            case EDocumentType.RapportInterpretationLacEauPdf:
                return 'Rapport Interpretation Lac Eau Pdf';
            case EDocumentType.RapportEssaiLacPhytoXls:
                return 'Rapport Essai Lac Phyto xls';
            case EDocumentType.RapportEssaiLacPhytoPdf:
                return 'Rapport Essai Lac Phyto Pdf';
            case EDocumentType.RapportInterpretationLacPhytoXls:
                return 'Rapport Interpretation Lac Phyto xls';
            case EDocumentType.RapportInterpretationLacPhytoPdf:
                return 'Rapport Interpretation Lac Phyto Pdf';
            case EDocumentType.ExportStandardLac:
                return 'Export Standard Lac';
            case EDocumentType.SaisieMPhytCE:
                return 'Saisie Macrophytes';
            case EDocumentType.FeuillePaillasseTri:
                return 'Feuille paillasse de tri';
            case EDocumentType.DonneesSonde:
                return 'Données Sonde';
            case EDocumentType.ImportSubstratIML:
                return 'Import Substrat IML';
            case EDocumentType.RapportInterpretationLacEauSynthesePdf:
                return 'Rapport Interpretation Lac Eau Synthese Pdf';
            case EDocumentType.RapportInterpretationLacEauSyntheseXls:
                return 'Rapport Interpretation Lac Eau Synthese Xls';
            case EDocumentType.ResultatSEEEI2M2CEP:
                return 'Résultat SEEE I2M2CEP';
            default:
                return 'Not Set';
        }
    }

    static getPhaseName(phase: number) {
        switch (phase) {
            case 1:
                return 'Phase A';
            case 2:
                return 'Phase B';
            case 3:
                return 'Phase C';
            default:
                return 'Not Set';
        }
    }

    static getUnitName(unit: EUnit) {
        switch (unit) {
            case EUnit.Pourcentage:
                return '%';
            case EUnit.cm2:
                return 'cm²';
            case EUnit.m2:
                return 'm²';
            default:
                return 'Not Set';
        }
    }

    static getBullshitPhaseName(idx: number) {
        return `P${idx}`;
    }

    static getIBMRPhaseName(phase: number) {
        switch (phase) {
            case 1:
                return 'UR1';
            case 2:
                return 'UR2';
            default:
                return 'Not Set';
        }
    }

    static getMGCEPhaseName(phase: number) {
        switch (phase) {
            case 1:
                return 'Zone Berge';
            case 2:
                return 'Zone Intermediaire Accessible';
            case 3:
                return 'Zone Intermediaire Non Accessible';
            case 4:
                return 'Zone Profonde';
            default:
                return 'Not Set';
        }
    }

    static getMeteoName(meteo: EMeteo) {
        switch (meteo) {
            case EMeteo.Ensoleille:
                return 'Ensoleillé';
            case EMeteo.FaiblementNuageux:
                return 'Faiblement nuageux';
            case EMeteo.TempsHumide:
                return 'Temps humide';
            case EMeteo.PluieFine:
                return 'Pluie fine';
            case EMeteo.OragePluieForte:
                return 'Orage pluie forte';
            case EMeteo.Neige:
                return 'Neige';
            case EMeteo.Gel:
                return 'Gel';
            case EMeteo.FortementNuageux:
                return 'Fortement nuageux';
            case EMeteo.ConditionsCrepusculaires:
                return 'Conditions crépusculaires';
            default:
                return 'Not Set';
        }
    }

    static getEnsoleillementName(ensoleillement: EEnsoleillement) {
        switch (ensoleillement) {
            case EEnsoleillement.RiviereAssezCouverte50a90pc:
                return 'Rivière assez couverte';
            case EEnsoleillement.RiviereAssezDegagee10a50pc:
                return 'Rivière assez dégagée';
            case EEnsoleillement.RiviereCouverte90pc:
                return 'Rivière couverte';
            case EEnsoleillement.RiviereDegagee10pc:
                return 'Rivière dégagée';
            default:
                return 'Not Set';
        }
    }

    static getHydrologieName(hydrologie: Hydrologie) {
        switch (hydrologie) {
            case Hydrologie.BassesEaux:
                return 'Basses eaux';
            case Hydrologie.CrueDebordante:
                return 'Crue débordante';
            case Hydrologie.Inconnue:
                return 'Inconnue';
            case Hydrologie.LitPlein:
                return 'Lit plein';
            case Hydrologie.MoyennesEaux:
                return 'Moyennes eaux';
            case Hydrologie.PasDeau:
                return 'Pas d\'eau';
            case Hydrologie.TrousDeauFlaques:
                return 'Trous d\'eau, flaques';
            default:
                return 'Not Set';
        }
    }

    static getVariationDebitName(variateDebit: VariationDebit) {
        switch (variateDebit) {
            case VariationDebit.EnAugmentation:
                return 'En augmentation';
            case VariationDebit.EnDiminution:
                return 'En diminution';
            case VariationDebit.Inconnue:
                return 'Inconnue';
            case VariationDebit.Irregulier:
                return 'Irrégulier';
            case VariationDebit.Stable:
                return 'Stable';
            default:
                return 'Not Set';
        }
    }

    static getLimpiditeName(limpidite: Limpidite) {
        switch (limpidite) {
            case Limpidite.Inconnu:
                return 'Inconnu';
            case Limpidite.LegerementTrouble:
                return 'Légèrement trouble';
            case Limpidite.Limpide:
                return 'Limpide';
            case Limpidite.Trouble:
                return 'Trouble';
            default:
                return 'Not Set';
        }
    }

    static getVisibiliteName(visibilite: VisibiliteFond) {

        switch (visibilite) {
            case VisibiliteFond.BonneVisibilite:
                return 'Bonne visibilité';
            case VisibiliteFond.FaibleVisibilite:
                return 'Faible visibilité';
            case VisibiliteFond.FondsNonVisibles:
                return 'Fonds non visibles';
            case VisibiliteFond.Inconnue:
                return 'Inconnue';
            case VisibiliteFond.MoyenneVisibilite:
                return 'Moyenne visibilité';
            default:
                return 'Not Set';
        }
    }

    static getOdeurName(odeur: Odeur) {

        switch (odeur) {
            case Odeur.Forte:
                return 'Forte';
            case Odeur.Inconnu:
                return 'Inconnue';
            case Odeur.Legere:
                return 'Légère';
            case Odeur.Sans:
                return 'Sans';
            default:
                return 'Not Set';
        }
    }

    static getTeinteName(teinte: Teinte) {
        switch (teinte) {
            case Teinte.Blanc:
                return 'Blanc';
            case Teinte.Bleu:
                return 'Bleu';
            case Teinte.BleuVert:
                return 'Bleu vert';
            case Teinte.Gris:
                return 'Gris';
            case Teinte.Incolore:
                return 'Incolore';
            case Teinte.Jaune:
                return 'Jaune';
            case Teinte.JauneMarron:
                return 'Jaune marron';
            case Teinte.MarronClair:
                return 'Marron clair';
            case Teinte.MarronFonce:
                return 'Marron foncé';
            case Teinte.Noir:
                return 'Noir';
            case Teinte.Vert:
                return 'Vert';
            case Teinte.VertJaune:
                return 'Vert Jaune';
            default:
                return 'Not Set';
        }
    }

    static getSituationHydrologie6semName(situation: SituationHydrologie6sem) {
        switch (situation) {
            case SituationHydrologie6sem.EvenementHydroExceptionnel:
                return 'Evénement hydrologique exceptionnel';
            case SituationHydrologie6sem.EvenementHydroImportant:
                return 'Evénement hydrologique important';
            case SituationHydrologie6sem.EvenementHydroModere:
                return 'Evénement hydrologique modéré';
            case SituationHydrologie6sem.Inconnu:
                return 'Inconnu';
            case SituationHydrologie6sem.Stable:
                return 'Stable';
            default:
                return 'Not Set';
        }
    }

    static getODRGName(odr: OccupationDominanteRiveGauche) {
        switch (odr) {
            case OccupationDominanteRiveGauche.Autre:
                return 'Autre';
            case OccupationDominanteRiveGauche.Canal:
                return 'Canal';
            case OccupationDominanteRiveGauche.Culture:
                return 'Culture';
            case OccupationDominanteRiveGauche.EspaceVertJardin:
                return 'Espace vert jardin';
            case OccupationDominanteRiveGauche.Feuillus:
                return 'Feuillus';
            case OccupationDominanteRiveGauche.Friche:
                return 'Friche';
            case OccupationDominanteRiveGauche.GravierePlanDeau:
                return 'Gravier plan d\'eau';
            case OccupationDominanteRiveGauche.Inconnue:
                return 'Inconnue';
            case OccupationDominanteRiveGauche.Prairie:
                return 'Prairie';
            case OccupationDominanteRiveGauche.Resineux:
                return 'Résineux';
            case OccupationDominanteRiveGauche.Urbanise:
                return 'Urbanisé';
            case OccupationDominanteRiveGauche.ZoneHumide:
                return 'Zone humide';
            default:
                return 'Not Set';
        }
    }

    static getODRDName(odr: OccupationDominanteRiveDroite) {
        switch (odr) {
            case OccupationDominanteRiveDroite.Autre:
                return 'Autre';
            case OccupationDominanteRiveDroite.Canal:
                return 'Canal';
            case OccupationDominanteRiveDroite.Culture:
                return 'Culture';
            case OccupationDominanteRiveDroite.EspaceVertJardin:
                return 'Espace vert jardin';
            case OccupationDominanteRiveDroite.Feuillus:
                return 'Feuillus';
            case OccupationDominanteRiveDroite.Friche:
                return 'Friche';
            case OccupationDominanteRiveDroite.GravierePlanDeau:
                return 'Gravier plan d\'eau';
            case OccupationDominanteRiveDroite.Inconnue:
                return 'Inconnue';
            case OccupationDominanteRiveDroite.Prairie:
                return 'Prairie';
            case OccupationDominanteRiveDroite.Resineux:
                return 'Résineux';
            case OccupationDominanteRiveDroite.Urbanise:
                return 'Urbanisé';
            case OccupationDominanteRiveDroite.ZoneHumide:
                return 'Zone humide';
            default:
                return 'Not Set';
        }
    }

    static getNatureBergeGaucheName(nbg: NatureBergeGauche) {
        switch (nbg) {
            case NatureBergeGauche.Artificielle:
                return 'Artificielle';
            case NatureBergeGauche.Enrochement:
                return 'Enrochement';
            case NatureBergeGauche.Inconnue:
                return 'Inconnue';
            case NatureBergeGauche.Naturelle:
                return 'Naturelle';
            default:
                return 'Not Set';
        }
    }

    static getNatureBergeDroiteName(nbd: NatureBergeDroite) {
        switch (nbd) {
            case NatureBergeDroite.Artificielle:
                return 'Artificielle';
            case NatureBergeDroite.Enrochement:
                return 'Enrochement';
            case NatureBergeDroite.Inconnue:
                return 'Inconnue';
            case NatureBergeDroite.Naturelle:
                return 'Naturelle';
            default:
                return 'Not Set';
        }
    }

    static getAspectAbordsName(aspect: AspectAbord) {
        switch (aspect) {
            case AspectAbord.Propre:
                return 'Propre';
            case AspectAbord.Sale:
                return 'Sale';
            default:
                return 'Not Set';
        }
    }

    static getPresenceSeuilName(seuil: PresenceSeuil) {
        switch (seuil) {
            case PresenceSeuil.Absence:
                return 'Absence';
            case PresenceSeuil.Amont:
                return 'Amont';
            case PresenceSeuil.Aval:
                return 'Aval';
            case PresenceSeuil.EntreDeuxSeuils:
                return 'Entre deux seuils';
            case PresenceSeuil.Inconnue:
                return 'Inconnue';
            case PresenceSeuil.PlusieursSeuilsInterieurStation:
                return 'Plusieurs seuils intérieur station';
            case PresenceSeuil.PrelevementSurSeuil:
                return 'Prélèvement sur seuil';
            case PresenceSeuil.SeuilInterieurStation:
                return 'Seuil intérieur station';
            default:
                return 'Not Set';
        }
    }

    static getPresenceGueName(gue: PresenceGué) {
        switch (gue) {
            case PresenceGué.Absence:
                return 'Absence';
            case PresenceGué.Amont:
                return 'Amont';
            case PresenceGué.Aval:
                return 'Aval';
            case PresenceGué.EntreDeuxGues:
                return 'Entre deux gués';
            case PresenceGué.GueInterieurStation:
                return 'Gué intérieur station';
            case PresenceGué.Inconnue:
                return 'Inconnue';
            default:
                return 'Not Set';
        }
    }

    static getClasseVitesseName(vitesse: ClasseVitesse) {
        switch (vitesse) {
            case ClasseVitesse.N1:
                return 'N1: < 5 cm/s';
            case ClasseVitesse.N2:
                return 'N2: > 150 cm/s';
            case ClasseVitesse.N3:
                return 'N3: 5 à 25 cm/s ';
            case ClasseVitesse.N4:
                return 'N4: 75 à 150 cm/s';
            case ClasseVitesse.N5:
                return 'N5: 25 à 75 cm/s';
            case ClasseVitesse.N6:
                return 'N6: > 75 cm/s';
            default:
                return 'Not Set';
        }
    }

    static getOutilPrelevementName(outil: TypeOutilPrelevement) {
        switch (outil) {
            case TypeOutilPrelevement.Brosse:
                return 'Brosse';
            case TypeOutilPrelevement.Scalpel:
                return 'Scalpel';
            case TypeOutilPrelevement.Racloir:
                return 'Racloir';
            default:
                return 'Not Set';
        }
    }

    static getSupportIBDName(support: SupportIBD) {
        switch (support) {
            case SupportIBD.Algues:
                return 'Algues';
            // case SupportIBD.BranchageRacines:
            //     return 'Branchage racines';
            case SupportIBD.Bryophytes:
                return 'Bryophytes';
            // case SupportIBD.Graviers:
            //     return 'Graviers';
            case SupportIBD.Helophytes:
                return 'Hélophytes';
            case SupportIBD.Hydrophytes:
                return 'Hydrophytes';
            // case SupportIBD.Litieres:
            //     return 'Litières';
            // case SupportIBD.MarneArgile:
            //     return 'Marnes argile';
            case SupportIBD.PierreGalet:
                return 'Pierres galets';
            case SupportIBD.RochesDalles:
                return 'Roches dalles';
            // case SupportIBD.SablesLimons:
            //     return 'Sables limons';
            // case SupportIBD.SedimentsFin:
            //     return 'Sédiments fins';
            case SupportIBD.SubstratArtificielDurIntroduit:
                return 'Substrat artificiel dur introduit';
            case SupportIBD.SubstratArtificielSoupleIntroduit:
                return 'Substrat artificiel souple introduit';
            default:
                return 'Not Set';
        }
    }

    static getOmbreName(ombre: Ombre) {
        switch (ombre) {
            case Ombre.Ouvert:
                return 'Ouvert';
            case Ombre.SemiOuvert:
                return 'Semi ouvert';
            case Ombre.Ferme:
                return 'Fermé';
            default:
                return 'Not Set';
        }
    }

    static getIntensiteColmatageName(col: IntensiteColmatage) {
        switch (col) {
            case IntensiteColmatage.Nul:
                return 'Nul';
            case IntensiteColmatage.Faible:
                return 'Faible';
            case IntensiteColmatage.Fort:
                return 'Fort';
            default:
                return 'Not Set';
        }
    }

    static getIBGNSubstratName(substrat: IBGNSub) {
        switch (substrat) {
            case IBGNSub.AlguesMarnes:
                return 'Algues Marnes';
            case IBGNSub.Bryophytes:
                return 'Bryophytes';
            case IBGNSub.HydrophytesImm:
                return 'Hydrophytes Imm';
            case IBGNSub.LitieresBranchagesRacines:
                return 'Litières Branchages Racines';
            case IBGNSub.PierresGalets:
                return 'Pierres Galets';
            case IBGNSub.Granulats:
                return 'Granulats';
            case IBGNSub.HydrophytesEmm:
                return 'Hydrophytes Emm';
            case IBGNSub.Vases:
                return 'Vases';
            case IBGNSub.SablesLimons:
                return 'Sables Limons';
            case IBGNSub.Blocs:
                return 'Blocs';
            default:
                return 'Not Set';
        }
    }

    static getMPCESubstratName(substrat: MPCESub) {
        switch (substrat) {
            case MPCESub.Algues:
                return 'Algues';
            case MPCESub.Bryophytes:
                return 'Bryophytes';
            case MPCESub.HydrophytesImm:
                return 'Hydrophytes Imm';
            case MPCESub.LitieresDebrisVegetaux:
                return 'Litières Débris Végétaux';
            case MPCESub.Pierres:
                return 'Pierres';
            case MPCESub.Granulats:
                return 'Granulats';
            case MPCESub.Vases:
                return 'Vases';
            case MPCESub.SablesLimons:
                return 'Sables Limons';
            case MPCESub.Blocs:
                return 'Blocs';
            case MPCESub.BranchagesRacines:
                return 'Branchages racines';
            case MPCESub.DallesMarnes:
                return 'Dalles marnes';
            case MPCESub.Helophytes:
                return 'Hélophytes';
            default:
                return 'Not Set';
        }
    }

    static getColmatageLitName(colmatage: ColmatageLit) {
        switch (colmatage) {
            case ColmatageLit.Absence:
                return 'Absence';
            case ColmatageLit.DebrisVegetauxGrossiers:
                return 'Débris Végétaux Grossiers';
            case ColmatageLit.DepotsIncrustants:
                return 'Dépots Incrustants';
            case ColmatageLit.FormationsBiologiques:
                return 'Formations Biologiques';
            case ColmatageLit.Litieres:
                return 'Litières';
            case ColmatageLit.Sables:
                return 'Sables';
            case ColmatageLit.SedimentsFins:
                return 'Sédiments Fins';
            case ColmatageLit.Vases:
                return 'Vases';
            default:
                return 'Not Set';
        }
    }

    static getMGCETypeSubstratName(support: MGCESub) {
        switch (support) {
            case MGCESub.Bryophytes:
                return 'Bryophytes';
            case MGCESub.Hydrophytes:
                return 'Hydrophytes';
            case MGCESub.LitieresDebrisVegetaux:
                return 'Litieres Débris Végétaux';
            case MGCESub.BranchagesRacines:
                return 'Branchages Racines';
            case MGCESub.PierresGalets:
                return 'Pierres Galets';
            case MGCESub.BlocsDeplacables:
                return 'Blocs Déplacables';
            case MGCESub.Granulats:
                return 'Granulats';
            case MGCESub.Helophytes:
                return 'Helophytes';
            case MGCESub.Vases:
                return 'Vases';
            case MGCESub.SablesLimons:
                return 'Sables Limons';
            case MGCESub.Algues:
                return 'Algues';
            case MGCESub.DallesBlocsNonDeplacables:
                return 'Dalles Blocs Non Déplacables';
            case MGCESub.Indetermine:
                return 'Indeterminé';
            default:
                return 'Not Set';
        }
    }

    static getMaterielName(m: Materiel) {
        switch (m) {
            case Materiel.Haveneau:
                return 'Haveneau';
            case Materiel.Surber:
                return 'Surber';
            case Materiel.DragueTriangulaire:
                return 'Drague Triangulaire';
            case Materiel.DragueCylindrique:
                return 'Drague Cylindrique';
            default:
                return 'Not Set';
        }
    }

    static getPresenceRejetName(r: PresenceRejet) {
        switch (r) {
            case PresenceRejet.Inconnue:
                return 'Inconnue';
            case PresenceRejet.Absence:
                return 'Absence';
            case PresenceRejet.Amont:
                return 'Amont';
            case PresenceRejet.Aval:
                return 'Aval';
            case PresenceRejet.EntreDeuxRejets:
                return 'Entre deux rejets';
            case PresenceRejet.PrelevementSurRejet:
                return 'Prélèvement';
            default:
                return 'Not Set';
        }
    }

    static GetImportanceVegetationBergeName(importance: EImportanceVegetationBerge) {
        switch (importance) {
            case EImportanceVegetationBerge.Absente:
                return 'Absente';
            case EImportanceVegetationBerge.Dense:
                return 'Dense';
            case EImportanceVegetationBerge.Eparse:
                return 'Eparse';
            default:
                return 'Not Set';
        }
    }

    static GetTypeVegetationName(type: ETypeVegetation) {
        switch (type) {
            case ETypeVegetation.Absence:
                return 'Absence';
            case ETypeVegetation.ArbustiveArboree:
                return 'Arbustive et/ou arborée';
            case ETypeVegetation.Culture:
                return 'Culture';
            case ETypeVegetation.Exotique:
                return 'Exotique';
            case ETypeVegetation.Herbacee:
                return 'Herbacée';
            case ETypeVegetation.LigneusePlantee:
                return 'Ligneuse plantée';
            default:
                return 'Not Set';
        }
    }
    static getIntensiteVent(type: EIntensiteVent) {
        switch (type) {
            case EIntensiteVent.Brise:
                return 'Brise';
            case EIntensiteVent.BriseModeree:
                return 'Brise Moderée';
            case EIntensiteVent.Faible:
                return 'Faible';
            case EIntensiteVent.Fort:
                return 'Fort';
            case EIntensiteVent.Moyen:
                return 'Moyen';
            case EIntensiteVent.NonRenseigne:
                return 'Non Renseigné';
            case EIntensiteVent.Nul:
                return 'Nul';
            default:
                return 'Not Set';
        }
    }

    static getSurfaceEauName(type: ESurfaceEau) {
        switch (type) {
            case ESurfaceEau.Agitee:
                return 'Agitée';
            case ESurfaceEau.FaiblementAgitee:
                return 'Faiblement Agitée';
            case ESurfaceEau.Lisse:
                return 'Lisse';
            case ESurfaceEau.TresAgitee:
                return 'Très Agitée';
            default:
                return 'Not Set';
        }
    }

    static getBloomAlgalName(type: EBloomAlgal) {
        switch (type) {
            case EBloomAlgal.Oui:
                return 'Oui';
            case EBloomAlgal.Non:
                return 'Non';
            default:
                return 'Not Set';
        }
    }

    static getSigneEmergenceName(type: ESigneEmergence) {
        switch (type) {
            case ESigneEmergence.Absente:
                return 'Absente';
            case ESigneEmergence.Faible:
                return 'Faible';
            case ESigneEmergence.Moderee:
                return 'Moderée';
            case ESigneEmergence.Forte:
                return 'Forte';
            default:
                return 'Not Set';
        }
    }

    static getPresenceMarnageName(type: EPresenceMarnage) {
        switch (type) {
            case EPresenceMarnage.Oui:
                return 'Oui';
            case EPresenceMarnage.Non:
                return 'Non';
            default:
                return 'Not Set';
        }
    }

    static getEmplacementMesureName(type: EEmplacementMesure) {
        switch (type) {
            case EEmplacementMesure.BergePonton:
                return 'Berge Ponton';
            case EEmplacementMesure.Embarcation:
                return 'Embarcation';
            default:
                return 'Not Set';
        }
    }

    static getMaterielEauIntegrePhytoName(type: EMaterielEauIntegrePhyto) {
        switch (type) {
            case EMaterielEauIntegrePhyto.BouteilleFermante:
                return 'Bouteille Fermante';
            case EMaterielEauIntegrePhyto.BouteilleIntegratice:
                return 'Bouteille Integratice';
            case EMaterielEauIntegrePhyto.Pompe:
                return 'Pompe';
            case EMaterielEauIntegrePhyto.Tuyau:
                return 'Tuyau';
            default:
                return 'Not Set';
        }
    }

    static getMaterielSedimentName(type: EMaterielSediment) {
        switch (type) {
            case EMaterielSediment.BenneEkman:
                return 'BenneEkman';
            case EMaterielSediment.BenneVanVeen:
                return 'BenneVanVeen';
            case EMaterielSediment.CarottierManuel:
                return 'CarottierManuel';
            default:
                return 'Not Set';
        }
    }

    static getMaterielEauPonctuelName(type: EMaterielEauPonctuel) {
        switch (type) {
            case EMaterielEauPonctuel.Bouteille:
                return 'Bouteille';
            case EMaterielEauPonctuel.Manuel:
                return 'Manuel';
            case EMaterielEauPonctuel.Perche:
                return 'Perche';
            default:
                return 'Not Set';
        }
    }

    static getIBMRRecouvrementName(recouvrement: ERecouvrement) {
        switch (recouvrement) {
            case ERecouvrement.Absent:
                return 'Absent';
            case ERecouvrement.Inferieur1:
                return 'Classe 1 - Inférieur à 1%';
            case ERecouvrement.Entre1Et10:
                return 'Classe 2 - Entre 1% et 10%';
            case ERecouvrement.Entre10Et25:
                return 'Classe 3 - Entre 10% et 25%';
            case ERecouvrement.Entre25Et75:
                return 'Classe 4 - Entre 25% et 75%';
            case ERecouvrement.Superieur75:
                return 'Classe 5 - Supérieur à 75%';
            default:
                return 'Not Set';
        }
    }

    static getAbondancePeriphytonName(abondance: EAbondancePeriphyton) {
        switch (abondance) {
            case EAbondancePeriphyton.Abondant:
                return 'Abondant';
            case EAbondancePeriphyton.Absent:
                return 'Absent';
            case EAbondancePeriphyton.PeuAbondant:
                return 'Peu abondant';
            case EAbondancePeriphyton.TresAbondant:
                return 'Très abondant';
            default:
                return 'Not Set';
        }
    }

    static getModeMesureName(mode: EModeMesure) {
        switch (mode) {
            case EModeMesure.Telemetre:
                return 'Télémètre';
            case EModeMesure.Decametre:
                return 'Décamètre';
            case EModeMesure.EstimationVisuelle:
                return 'Estimation Visuelle';
            case EModeMesure.TelemetreDecametre:
                return 'Télémètre + Décamètre';
            default:
                return 'Not Set';
        }
    }

    static getModeEstimationRecouvrementName(mode: EModeEstimationRecouvrement) {
        switch (mode) {
            case EModeEstimationRecouvrement.Bandes:
                return 'Bandes';
            case EModeEstimationRecouvrement.Facies:
                return 'Faciès';
            case EModeEstimationRecouvrement.Quadrats:
                return 'Quadrats';
            default:
                return 'Not Set';
        }
    }

    static getModePrelevementName(mode: EModePrelevement) {
        switch (mode) {
            case EModePrelevement.APied:
                return 'A Pied';
            case EModePrelevement.EnBateau:
                return 'En Bateau';
            case EModePrelevement.Mixte:
                return 'Mixte';
            case EModePrelevement.PointsContacts:
                return 'Points Contacts';
            default:
                return 'Not Set';
        }
    }

    static getZoneName(zone: EZone) {
        switch (zone) {
            case EZone.Berge:
                return 'Berge';
            case EZone.IntermediaireAccessible:
                return 'Intermediaire Accessible';
            case EZone.IntermediaireNonAccessible:
                return 'Intermediaire Non Accessible';
            case EZone.Profonde:
                return 'Profonde';
            default:
                return 'Not Set';
        }
    }

    static getImportanceName(zone: EImportance) {
        switch (zone) {
            case EImportance.Faible:
                return '1';
            case EImportance.Forte:
                return '2';
            case EImportance.Presence:
                return 'P';
            default:
                return 'Not Set';
        }
    }

    static getSecuriteMiseEauName(sec: ESecuriteMiseALEau) {
        switch (sec) {
            case ESecuriteMiseALEau.PasDeDanger:
                return 'Pas de danger';
            case ESecuriteMiseALEau.Difficile:
                return 'Difficile';
            case ESecuriteMiseALEau.Dangereux:
                return 'Dangereux';
            default:
                return 'Not Set';
        }
    }

    static getUniteUR1Name(u: EUniteUR1) {

        switch (u) {
            case EUniteUR1.Chenal:
                return 'Chenal';
            case EUniteUR1.RiveDroite:
                return 'Rive Droite';
            case EUniteUR1.UniteCourante:
                return 'Unité Courante';
            case EUniteUR1.UniteOmbragee:
                return 'Unité Ombragée';
            case EUniteUR1.Profonde:
                return 'Profonde';
            case EUniteUR1.Unique:
                return 'Unique';
            default:
                return 'Not Set';
        }
    }

    static getUniteUR2Name(u: EUniteUR2) {

        switch (u) {
            case EUniteUR2.Berge:
                return 'Berge';
            case EUniteUR2.RiveGauche:
                return 'Rive Gauche';
            case EUniteUR2.UniteEclairee:
                return 'Unité Eclairée';
            case EUniteUR2.UniteLente:
                return 'Unité Lente';
            case EUniteUR2.PeuProfonde:
                return 'Peu profonde';
            default:
                return 'Not Set';
        }
    }

    static getIMLSubstratMineralName(sm: EIMLTypeSubstratMineral) {

        switch (sm) {
            case EIMLTypeSubstratMineral.BD:
                return 'Blocs-Dalles';
            case EIMLTypeSubstratMineral.GA:
                return 'Galets';
            case EIMLTypeSubstratMineral.S:
                return 'Sables';
            case EIMLTypeSubstratMineral.GR:
                return 'Graviers';
            case EIMLTypeSubstratMineral.VAL:
                return 'Vase';
            default:
                return 'Not Set';
        }
    }

    static getIMLSubstratVegetalName(sv: EIMLTypeSubstratVegetal) {

        switch (sv) {
            case EIMLTypeSubstratVegetal.BR:
                return 'Bryophytes';
            case EIMLTypeSubstratVegetal.HE:
                return 'Hélophytes';
            case EIMLTypeSubstratVegetal.HF:
                return 'Hydrophytes flottants';
            case EIMLTypeSubstratVegetal.HI:
                return 'Hydrophytes immergés';
            case EIMLTypeSubstratVegetal.LI:
                return 'Litières débris organiques';
            case null as any:
                return 'Aucun';
            default:
                return 'Not Set';
        }
    }

    static getPhName(pH: EpH) {

        switch (pH) {
            case EpH.pH2:
                return 'pH2';
            case EpH.pH4:
                return 'pH4';
            case EpH.pH7005:
            case EpH.pH7010:
                return 'pH7';
            case EpH.pH10:
                return 'pH10';
            case EpH.pH12:
                return 'pH12';
            default:
                return 'Not Set';
        }
    }

    static getConductiviteName(cond: EConductivite) {

        switch (cond) {
            case EConductivite.C84:
                return '1413µS/cm';
            case EConductivite.C1413:
                return '84µS/cm';
            case EConductivite.C0:
                return '0µS/cm';
            default:
                return 'Not Set';
        }
    }
}
